

















import {Component, Vue, Prop} from 'vue-property-decorator';

@Component({
  name: 'product-list-toolbar-paginator'
})

export default class extends Vue {
  @Prop({required: true}) private dataSource: string;
  @Prop({default: 2}) private interval: number;

  private get currentPage(): number {
    return Number(this.$store.getters[`${this.dataSource}/currentPage`]);
  }

  private get totalPages(): number {
    return Number(this.$store.getters[`${this.dataSource}/totalPages`]);
  }

  private get paginationPages(): Array<number> {
    let pages = [];
    for (let i = this.paginationStart; i <= this.paginationEnd; i++) {
      pages.push(i);
    }
    return pages;
  }

  private get paginationStart(): number {
    return this.currentPage <= this.interval ? 1 : (this.currentPage - this.interval);
  }

  private get paginationEnd(): number {
    if ((this.currentPage + this.interval) < this.totalPages) {
      return this.currentPage + this.interval;
    }

    return this.totalPages;
  }

  private getPaginationUrl(page: number) {
    const baseUrl = `${document.location.protocol}//${document.location.hostname}${document.location.pathname}`;
    const urlSearchParams = Object.fromEntries(new URLSearchParams(window.location.search).entries());
    let query = [];

    urlSearchParams.page = `${page}`;

    Object.entries(urlSearchParams).forEach(element => {
      if (Array.isArray(element[1])) {
        element[1].forEach(subElement => query.push(`${element[0]}[]=${subElement}`));
      }

      query.push(`${element[0]}=${element[1]}`);
    });

    return query.length ? `${baseUrl}?${query.join('&')}` : baseUrl;
  }

  private updatePage(page: number): void {
    if (page !== this.currentPage) {
      if (this.dataSource === 'CatalogPageBuilder') {
        this.$store.dispatch(`${this.dataSource}/updatePage`, {page: page});
      } else {
        this.$store.dispatch(`${this.dataSource}/updatePage`, page);
      }
    }

    setTimeout(() => {
      const topToolbar = document.getElementsByClassName('catalog__category-toolbar-top');
      if (topToolbar.length) {
        window.scrollTo({top: (topToolbar[0] as HTMLElement).offsetTop - 220, left: 0, behavior: 'smooth'});
      }
    }, 100);
  }
}
